export const PAGE_INTEGRATION_LIST_LOADING = 'PAGE_INTEGRATION_LIST_LOADING';

export function loading({ loading }) {
  return {
    type: PAGE_INTEGRATION_LIST_LOADING,
    loading
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/integration/IntegrationList.js